(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-rail')) {
    customElements.define('product-rail', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-rail-track]');
        const section = this.closest('.shopify-section') || this.parentElement;
        this.prev = section.querySelector('[data-rail-prev]');
        this.next = section.querySelector('[data-rail-next]');
        if (!this.track) return;
        const step = () => {
          const card = this.track.firstElementChild;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          return card ? (card.getBoundingClientRect().width + gap) * Math.max(1, Math.floor(this.track.clientWidth / (card.getBoundingClientRect().width + gap))) : this.track.clientWidth;
        };
        this.prev?.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
        this.next?.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));
        this.update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth - 2;
          if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
          if (this.next) this.next.disabled = this.track.scrollLeft >= max;
        };
        this.track.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update);
        this.update();
      }
      disconnectedCallback() {
        window.removeEventListener('resize', this.update);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('store-footer')) {
    customElements.define('store-footer', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.desktop = window.matchMedia('(min-width: 750px)');
        const updateMenus = () => {
          this.querySelectorAll('.site-footer__block').forEach((details) => {
            if (this.desktop.matches) details.removeAttribute('name');
            else details.setAttribute('name', this.dataset.accordionGroup);
            details.open = this.desktop.matches;
            const summary = details.querySelector('summary');
            summary.tabIndex = this.desktop.matches ? -1 : 0;
            if (this.desktop.matches) summary.setAttribute('aria-disabled', 'true');
            else summary.removeAttribute('aria-disabled');
          });
        };
        this.desktop.addEventListener('change', updateMenus, { signal });
        updateMenus();
        this.addEventListener('click', (event) => {
          if (event.target.closest('.site-footer__block summary') && this.desktop.matches) event.preventDefault();
          const cookies = event.target.closest('[data-footer-cookie-settings]');
          if (cookies) this.openCookieSettings(cookies);
        }, { signal });
        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-footer-localization-select]')) event.target.form.requestSubmit();
        }, { signal });
        this.addEventListener('shopify:block:select', (event) => {
          const details = event.target.closest('.site-footer__block');
          if (details) details.open = true;
        }, { signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      async openCookieSettings(button) {
        if (button.disabled) return;
        const error = this.querySelector('[data-footer-cookie-error]');
        error.hidden = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        try {
          if (!window.privacyBanner?.showPreferences) {
            await new Promise((resolve, reject) => {
              const script = document.createElement('script');
              script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
              script.onload = resolve;
              script.onerror = reject;
              document.head.append(script);
            });
          }
          await window.privacyBanner.showPreferences();
        } catch {
          error.hidden = false;
        } finally {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('announcement-slider')) {
    customElements.define('announcement-slider', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.index = 0;
        this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.index - 1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1));
        const interval = Number(this.dataset.interval);
        if (this.slides.length > 1 && interval > 0) {
          this.timer = window.setInterval(() => this.show(this.index + 1), interval);
          this.addEventListener('mouseenter', () => window.clearInterval(this.timer), { once: true });
        }
      }
      show(index) {
        if (!this.slides.length) return;
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === this.index;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
        });
      }
    });
  }
  if (!customElements.get('mobile-search')) {
    customElements.define('mobile-search', class extends HTMLElement {
      connectedCallback() {
        this.details = this.closest('details');
        this.input = this.querySelector('input[type="search"]');
        this.recentSection = this.querySelector('[data-recent-section]');
        this.recentGrid = this.querySelector('[data-recent-grid]');
        this.storeCurrentProduct();
        this.renderRecent();
        this.details?.addEventListener('toggle', () => {
          if (!this.details.open) return;
          this.renderRecent();
          window.requestAnimationFrame(() => this.input?.focus());
        });
        this.querySelector('[data-clear-recent]')?.addEventListener('click', () => {
          try { window.localStorage.removeItem(this.dataset.storageKey); } catch (error) {}
          this.renderRecent();
        });
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          this.details?.removeAttribute('open');
          this.details?.querySelector('summary')?.focus();
        });
      }
      readRecent() {
        try {
          const products = JSON.parse(window.localStorage.getItem(this.dataset.storageKey) || '[]');
          return Array.isArray(products) ? products : [];
        } catch (error) {
          return [];
        }
      }
      storeCurrentProduct() {
        if (!this.dataset.currentProductId) return;
        const product = {
          id: this.dataset.currentProductId,
          title: this.dataset.currentProductTitle,
          url: this.dataset.currentProductUrl,
          image: this.dataset.currentProductImage || '',
          price: this.dataset.currentProductPrice
        };
        const products = this.readRecent().filter((item) => item.id !== product.id);
        products.unshift(product);
        try { window.localStorage.setItem(this.dataset.storageKey, JSON.stringify(products.slice(0, 4))); } catch (error) {}
      }
      renderRecent() {
        const products = this.readRecent().slice(0, 4);
        this.recentGrid?.replaceChildren(...products.map((product) => this.createCard(product)));
        if (this.recentSection) this.recentSection.hidden = products.length === 0;
      }
      createCard(product) {
        const link = document.createElement('a');
        link.className = 'mobile-search__card';
        link.href = product.url;
        const media = document.createElement('span');
        media.className = 'mobile-search__card-image';
        if (product.image) {
          const image = document.createElement('img');
          image.src = product.image;
          image.alt = product.title;
          image.loading = 'lazy';
          media.append(image);
        }
        const title = document.createElement('span');
        title.className = 'mobile-search__card-title';
        title.textContent = product.title;
        const price = document.createElement('span');
        price.className = 'mobile-search__card-price';
        price.textContent = product.price;
        link.append(media, title, price);
        return link;
      }
    });
  }
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-close-details]');
    if (!button) return;
    const details = button.closest('details');
    if (!details?.classList.contains('mobile-menu')) {
      details?.removeAttribute('open');
      return;
    }
    if (!details.open || details.classList.contains('is-closing')) return;
    const panel = details.querySelector('.mobile-menu__panel');
    details.classList.add('is-closing');
    let timeout;
    const finish = () => {
      window.clearTimeout(timeout);
      panel?.removeEventListener('transitionend', handleTransitionEnd);
      details.removeAttribute('open');
      details.classList.remove('is-closing');
    };
    const handleTransitionEnd = (transitionEvent) => {
      if (transitionEvent.target === panel && transitionEvent.propertyName === 'transform') finish();
    };
    panel?.addEventListener('transitionend', handleTransitionEnd);
    timeout = window.setTimeout(finish, 450);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-slider')) {
    customElements.define('hero-slider', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-hero-slide]')];
        this.progress = this.querySelector('[data-hero-progress]');
        this.index = 0;
        if (this.slides.length < 2) return;

        this.querySelector('[data-hero-prev]')?.addEventListener('click', () => this.show(this.index - 1));
        this.querySelector('[data-hero-next]')?.addEventListener('click', () => this.show(this.index + 1));

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (Number(this.dataset.autoplay) > 0 && !reduceMotion && this.progress) {
          this.classList.add('is-autoplay');
          this.progress.addEventListener('animationend', () => this.show(this.index + 1));
          const pause = () => this.classList.add('is-paused');
          const resume = () => this.classList.remove('is-paused');
          this.addEventListener('pointerenter', (event) => { if (event.pointerType === 'mouse') pause(); });
          this.addEventListener('pointerleave', (event) => { if (event.pointerType === 'mouse') resume(); });
          this.addEventListener('focusin', pause);
          this.addEventListener('focusout', (event) => { if (!this.contains(event.relatedTarget)) resume(); });
        }
        this.updateProgress();

        let startX = null;
        let startY = null;
        this.addEventListener('touchstart', (event) => {
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
        }, { passive: true });
        this.addEventListener('touchend', (event) => {
          if (startX === null) return;
          const deltaX = event.changedTouches[0].clientX - startX;
          const deltaY = event.changedTouches[0].clientY - startY;
          if (Math.abs(deltaX) > 48 && Math.abs(deltaX) > Math.abs(deltaY)) this.show(this.index + (deltaX < 0 ? 1 : -1));
          startX = null;
        });

        this.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.indexOf(event.target.closest('[data-hero-slide]'));
          if (index >= 0) this.show(index);
          this.classList.add('is-paused');
        });
        this.addEventListener('shopify:block:deselect', () => this.classList.remove('is-paused'));
      }

      show(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === this.index;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
          slide.inert = !isActive;
        });
        const counter = this.querySelector('[data-hero-current]');
        if (counter) counter.textContent = String(this.index + 1).padStart(2, '0');
        this.updateProgress();
      }

      updateProgress() {
        if (!this.progress) return;
        this.style.setProperty('--hero-position', String((this.index + 1) / this.slides.length));
        this.progress.style.animation = 'none';
        void this.progress.offsetWidth;
        this.progress.style.animation = '';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  if (!customElements.get('collection-layout')) {
    customElements.define('collection-layout', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-filter-dialog]');
        this.querySelector('[data-open-filters]')?.addEventListener('click', () => this.dialog?.showModal());
        this.querySelector('[data-close-filters]')?.addEventListener('click', () => this.dialog?.close());
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.viewButtons = [...this.querySelectorAll('[data-collection-view]')];
        this.viewButtons.forEach((button) => button.addEventListener('click', () => this.setView(button.dataset.collectionView)));
        this.setView(this.dataset.view || 'grid');
      }
      setView(view) {
        this.dataset.view = view;
        this.viewButtons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.collectionView === view)));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', class extends HTMLElement {
      connectedCallback() {
        this.items = [...this.querySelectorAll('[data-gallery-item]')];
        this.counter = this.querySelector('[data-gallery-current]');
        this.viewport = this.querySelector('[data-gallery-viewport]');
        const initialIndex = this.items.findIndex((item) => item.dataset.mediaId === this.dataset.initialMediaId);
        this.index = initialIndex >= 0 ? initialIndex : 0;
        this.querySelector('[data-gallery-previous]')?.addEventListener('click', () => this.show(this.index - 1));
        this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.show(this.index + 1));
        this.viewport?.addEventListener('touchstart', (event) => { this.touchStartX = event.changedTouches[0].clientX; }, { passive: true });
        this.viewport?.addEventListener('touchend', (event) => {
          const distance = event.changedTouches[0].clientX - this.touchStartX;
          if (Math.abs(distance) >= 50) this.show(this.index + (distance < 0 ? 1 : -1));
        }, { passive: true });
        this.show(this.index);
      }
      show(index) {
        if (!this.items.length) return;
        this.index = (index + this.items.length) % this.items.length;
        this.items.forEach((item, itemIndex) => {
          const isActive = itemIndex === this.index;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-hidden', String(!isActive));
          if (!isActive) item.querySelector('video')?.pause();
        });
        if (this.counter) this.counter.textContent = String(this.index + 1);
      }
      selectMedia(mediaId) {
        const index = this.items.findIndex((item) => item.dataset.mediaId === String(mediaId));
        if (index >= 0) this.show(index);
      }
    });
  }

  if (!customElements.get('product-options')) {
    customElements.define('product-options', class extends HTMLElement {
      connectedCallback() {
        this.variants = JSON.parse(this.querySelector('[data-product-variants]').textContent);
        this.addEventListener('change', (event) => {
          if (event.target.matches('.product-option input')) this.updateVariant();
        });
        this.updateVariant();
      }
      updateVariant() {
        const selected = [...this.querySelectorAll('fieldset')].map((fieldset) => fieldset.querySelector('input:checked')?.value);
        this.updateSelectedLabels();
        this.updateAvailability(selected);
        const variant = selected.length ? this.variants.find((candidate) => candidate.options.every((option, index) => option === selected[index])) : this.variants[0];
        const input = this.querySelector('[data-variant-id]');
        const button = this.querySelector('[data-add-button]');
        const label = this.querySelector('[data-add-text]');
        if (!variant) {
          input.value = '';
          button.disabled = true;
          label.textContent = this.dataset.unavailableLabel;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
        input.value = variant.id;
        button.disabled = !variant.available;
        label.textContent = variant.available ? this.dataset.addLabel : this.dataset.soldOutLabel;
        const price = this.querySelector('[data-product-price]');
        const compare = this.querySelector('[data-compare-price]');
        price.textContent = new Intl.NumberFormat(document.documentElement.lang, { style: 'currency', currency: this.dataset.currency }).format(variant.price / 100);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compare.hidden = false;
          compare.textContent = new Intl.NumberFormat(document.documentElement.lang, { style: 'currency', currency: this.dataset.currency }).format(variant.compare_at_price / 100);
        } else {
          compare.hidden = true;
          compare.textContent = '';
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
        if (variant.featured_media) this.closest('.main-product')?.querySelector('[data-product-gallery]')?.selectMedia?.(variant.featured_media.id);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      updateSelectedLabels() {
        [...this.querySelectorAll('fieldset')].forEach((fieldset) => {
          const label = fieldset.querySelector('[data-option-selected]');
          const value = fieldset.querySelector('input:checked')?.value;
          if (label && value) label.textContent = value;
        });
      }
      updateAvailability(selectedValues) {
        const selected = selectedValues || [...this.querySelectorAll('fieldset')].map((fieldset) => fieldset.querySelector('input:checked')?.value);
        [...this.querySelectorAll('fieldset')].forEach((fieldset, optionIndex) => {
          fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
            const available = this.variants.some((variant) => variant.available && variant.options.every((option, index) => {
              if (index === optionIndex) return option === input.value;
              if (index < optionIndex) return option === selected[index];
              return true;
            }));
            input.disabled = !available;
            input.closest('.product-option')?.classList.toggle('product-option--unavailable', !available);
          });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  if (!customElements.get('search-layout')) {
    customElements.define('search-layout', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-filter-dialog]');
        this.querySelector('[data-open-filters]')?.addEventListener('click', () => this.dialog?.showModal());
        this.querySelector('[data-close-filters]')?.addEventListener('click', () => this.dialog?.close());
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.viewButtons = [...this.querySelectorAll('[data-search-view]')];
        this.viewButtons.forEach((button) => button.addEventListener('click', () => this.setView(button.dataset.searchView)));
        this.setView(this.dataset.view || 'grid');
      }
      setView(view) {
        this.dataset.view = view;
        this.viewButtons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.searchView === view)));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.observer = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          this.observer.disconnect();
          this.loadRecommendations();
        }, { rootMargin: '0px 0px 300px 0px' });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.controller?.abort();
        cancelAnimationFrame(this.scrollFrame);
      }

      async loadRecommendations() {
        try {
          const response = await fetch(this.dataset.url, { signal: this.controller.signal });
          if (!response.ok) return;
          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const recommendations = documentFragment.querySelector('product-recommendations');
          if (!this.isConnected || !recommendations?.innerHTML.trim()) return;
          this.innerHTML = recommendations.innerHTML;
          this.initializeCarousel();
        } catch (error) {
          if (error.name !== 'AbortError') this.hidden = true;
        }
      }

      initializeCarousel() {
        const track = this.querySelector('.recommendations__track');
        if (!track) return;
        const controls = this.querySelector('.recommendations__controls');
        const previous = this.querySelector('[data-recommendations-previous]');
        const next = this.querySelector('[data-recommendations-next]');
        const signal = this.controller.signal;
        const update = () => {
          const maximum = track.scrollWidth - track.clientWidth;
          const position = Math.abs(track.scrollLeft);
          controls.hidden = maximum <= 1;
          track.tabIndex = maximum > 1 ? 0 : -1;
          previous.disabled = position <= 1;
          next.disabled = position >= maximum - 1;
        };
        const scroll = (direction) => {
          const firstCard = track.firstElementChild;
          if (!firstCard) return;
          const style = getComputedStyle(track);
          const step = firstCard.getBoundingClientRect().width + parseFloat(style.columnGap);
          const inlineDirection = style.direction === 'rtl' ? -1 : 1;
          track.scrollBy({ left: direction * inlineDirection * step });
        };
        previous.addEventListener('click', () => scroll(-1), { signal });
        next.addEventListener('click', () => scroll(1), { signal });
        track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(update);
        }, { passive: true, signal });
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(track);
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
